<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-lote') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vs-select
                        :id="generateId(1)"
                        ref="loteInput"
                        :title="'lote'"
                        :options="lotes"
                        v-model="loteproduto.lote"
                        :search="loadLotes"
                        :onChange="updateLote"
                        :placeholder="'lote'"
                        :disabled="isEdit"
                        :invalid="isNull(loteproduto.lote)"
                        :loading="loadingLote"
                    />
                </div>
                <div class="column is-6">
                    <vs-select
                        :id="generateId(2)"
                        ref="empresaInput"
                        :title="'empresa'"
                        :options="empresas"
                        v-model="loteproduto.empresa"
                        :search="loadEmpresa"
                        :onChange="updateEmpresa"
                        :placeholder="'empresa'"
                        :invalid="isNull(loteproduto.empresa)"
                        :loading="loadingEmpresa"
                    />
                </div>
                <div class="column is-6">
                    <verified-date-picker
                        :id="generateId(4)"
                        ref="dataFabricacaoInput"
                        :subtractDateYears="2"
                        :addDateYears="2"
                        :yearsRange="[-2,10]"
                        v-model="loteproduto.datafabricacao"
                        placeholder="selecione-uma-data"
                        title="data-fabricacao"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(loteproduto.datafabricacao)"
                        :required="true"
                        :showClean="false"
                    />
                </div>
                <div class="column is-6">
                    <verified-date-picker
                        :id="generateId(4)"
                        ref="dataValidadeInput"
                        :subtractDateYears="0"
                        :addDateYears="2"
                        :yearsRange="[-2,10]"
                        v-model="loteproduto.datavalidade"
                        placeholder="selecione-uma-data"
                        title="data-validade"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(loteproduto.datavalidade)"
                        :required="true"
                        :showClean="false"
                    />
                </div>
                <div class="column is-6" >
                    <v-money
                        :id="generateId(3)"
                        ref="qtdeInput"
                        v-model="loteproduto.qtde"
                        title="quantidade"
                        :min="0"
                        :max="10000"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssProdutoLoteService from "@/services/vendas/produto/AssProdutoLoteService";
// COMPONENTS
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import LoteProdutoValidation from "@/services/validations/vendas/produto/LoteProdutoValidation";

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        idProduto: 0,
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            lotes:[],
            empresas:[],
            loadingLote: false,
            loadingEmpresa: false,
            loteproduto: {
                lote: null,
                empresa: null,
                datafabricacao: null,
                datavalidade: null,
                situacao: 1,
            },
            service: new AssProdutoLoteService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            idproduto: 0,
            column: 'descricao',
            order: 'asc',
            isLoading: false,
            isEdit: false,
            validate: null,
            msgs: [],
        }
    },
    created() {
        this.carregarDados();
    },
    methods: {
        carregarDados() {
            this.validation = new LoteProdutoValidation(this.msgs);

            if(this.selected){
                this.isEdit = true
                this.loadAssProdutoLote()
            }
        
            this.loadLotes()
            this.loadEmpresa()
        },
        save() {
            const lotTemp = this.mapOnSave(this.loteproduto)

            if (this.validation.validate(lotTemp, this.$refs)) {
                this.isLoading = true;
                this.service.save(lotTemp)
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            }
        },
        loadAssProdutoLote(){
            this.loadingLote = true;
            this.service
            .find(this.selected.idassprodutolote)
            .then(this.mapAssLoteProduto)
            .catch(e => {
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.loadingLote = false;
            });
        },
        loadLotes(){
            this.loadingLote = true;
            this.service
            .listAllByProductNaoAss(this.idProduto)
            .then(this.mapLote)
            .then(value => {
                this.lotes = value;
            })
            .catch(e => {
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.loadingLote = false;
            });
        },
        loadEmpresa() {
            this.loadingEmpresa = true;
            this.empresaService
                .findAllCombo()
                .then(this.mapEmpresa)
                .then((value) => {
                    this.empresas = value;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(() => {
                    this.loadingEmpresa = false;
                });
        },
        updateLote(lote) {
            if (lote) {
                this.loteproduto.lote = lote;
            } else {
                this.loteproduto.lote = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        updateEmpresa(empresa) {
            if (empresa) {
                this.loteproduto.empresa = empresa;
            } else {
                this.loteproduto.empresa = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        mapLote(body) {
            return body.map(m => {
                return {
                    idlote: m.idlote,
                    descricao: m.descricao,
                    label: m.descricao
                };
            });
        },
        mapAssLoteProduto(item){
            this.loteproduto = {
                idassprodutolote: item.idassprodutolote,
                lote: item.lote ? {
                    idlote: item.lote.idlote,
                    descricao: item.lote.descricao,
                    label: item.lote.descricao,
                } : null,
                empresa: item.empresa ? {
                    idempresa: item.empresa.idempresa,
                    rsocial: item.empresa.nome,
                    label: item.empresa.nome,
                } : null,
                qtde: item.qtde,
                situacao: item.situacao,
                datafabricacao: new Date(item.datafabricacao),
                datavalidade: new Date(item.datavalidade),
            }
        },
        mapEmpresa(item){
            return item.content.map((r)=>{
                return {
                    idempresa: r.idempresa,
                    rsocial: r.rsocial,
                    label: r.rsocial
                }
            })
        },
        mapOnSave(item){
            return {
                idassprodutolote: item.idassprodutolote,
                idproduto: this.idProduto,
                lote: {idlote: item.lote ? item.lote.idlote : null},
                idempresa: item.empresa? item.empresa.idempresa : null,
                qtde: item.qtde,
                datafabricacao: item.datafabricacao,
                datavalidade: item.datavalidade,
                situacao: item.situacao,
            }
        },

        generateId(numberId){
            return this.$route.name+'-produto-'+numberId;
        },
        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;
}
</style>